import { ActivityState } from '../../types/activity/activity.types';
import {
  ActivityActionTypes,
  GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST,
  GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS,
  GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE,
} from './activity.types';

const initialState: ActivityState = {
  contactAttributeActivity: [],
  loading: false,
  error: null,
  pagination: {
    page: 0,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

const activityReducer = (
  state = initialState,
  action: ActivityActionTypes
): ActivityState => {
  switch (action.type) {
    case GET_CONTACT_ATTRIBUTE_ACTIVITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_CONTACT_ATTRIBUTE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        contactAttributeActivity: action.payload.activities,
        pagination: action.payload.pagination,
        error: null,
      };

    case GET_CONTACT_ATTRIBUTE_ACTIVITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default activityReducer;
